import { BaseService } from '../service/base';

export class SecurityRoleDTO {
    id!: string;
    name!: string;
    isAdmin = false;
}

export class VisionSecurityService extends BaseService {
    isAdmin = false;

    public async init() {
        await this.getAssignedRoles().then((roles) => {
            this.isAdmin = roles.some((role) => role.isAdmin);
        });
    }

    public async getAssignedRoles(): Promise<SecurityRoleDTO[]> {
        const url = `${this.url}/api/v1/${this.orgid}/security/roles/assigned`;
        const response = await this.get<SecurityRoleDTO[]>(url);
        return this.getParsedBody(response);
    }

    public async getAvailableRoles(): Promise<SecurityRoleDTO[]> {
        const url = `${this.url}/api/v1/${this.orgid}/security/roles`;
        const response = await this.get<SecurityRoleDTO[]>(url);
        return this.getParsedBody(response);
    }
}
